import { Drawer } from "vaul"

import { GetStartedModalItem } from "./Item"

import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import React from "react"

type Props = {
  heading: string
  subheading: string
  items: Storyblok.GetStartedItem[]
  onClose: () => void
}

export const GetStartedModalMenu = ({
  heading,
  subheading,
  items,
  onClose,
}: Props) => {
  return (
    <>
      <Drawer.Title className="mb-24 mt-40 px-[25px] md:mb-[38px] md:mt-48">
        <Typography
          text={heading}
          size="lead-sm"
          weight="medium"
          font="grotesk"
          color={Color.Charcoal}
        />

        <Typography
          text={subheading}
          size="body-sm"
          weight="book"
          font="grotesk"
          color={Color.Charcoal}
        />
      </Drawer.Title>

      {items?.map((item) => {
        return (
          <GetStartedModalItem
            key={item._uid}
            label={item.label}
            description={item.description}
            descriptionMobile={item.descriptionMobile}
            image={item.image?.filename}
            ctaLink={item.ctaLink}
            trackingEvent={item.trackingEvent}
            trackingEventKey={item.trackingEventKey}
            trackingEventValue={item.trackingEventValue}
            onClick={onClose}
          />
        )
      })}
    </>
  )
}
